import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "./Constants";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const AddQuestionType = () => {
  const [formData, setFormData] = useState({
    dept: "",
    question_type: "",
    question_limit: "",
  });

  const [departments, setDepartments] = useState([]);
  const [selectedDeptOption, setSelectedDeptOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔹 Fetch Department List
  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(
        `${BASE_URL}dept`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (data.status) {
        const formatted = data.departments.map((item) => ({
          value: item.dept_name,
          label: item.dept_name,
        }));

        setDepartments(formatted);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  // 🔹 Handle Question Change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 🔹 Handle Department Change
  const handleDeptChange = (selectedOption) => {
    setSelectedDeptOption(selectedOption);

    setFormData((prev) => ({
      ...prev,
      dept: selectedOption ? selectedOption.value : "",
    }));
  };

  // 🔹 Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("authToken");

    if (!formData.dept || !formData.question_type) {
      alert("Please fill all fields");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(
        `${BASE_URL}add_question_type`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok && data.status) {
        alert("Question Type Added Successfully ✅");
        navigate("/PreparequestionType");
      } else {
        alert(data.message || "Failed to add question type");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">

            <h4 className="fw-bold mb-4">
              Add Question Type
            </h4>

            <div className="card shadow-sm border-0">
              <div className="card-body">

                <form onSubmit={handleSubmit}>
                  <div className="row">

                    {/* Department Dropdown */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-semibold">
                        Department
                      </label>
                      <Select
                        options={departments}
                        value={selectedDeptOption}
                        onChange={handleDeptChange}
                        placeholder="Search & Select Department"
                        isClearable
                      />
                    </div>

                    {/* Question */}
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-semibold">
                        Question Type
                      </label>
                      <textarea
                        name="question_type"
                        className="form-control input-font"
                        placeholder="Enter Question Type"
                        rows="4"
                        value={formData.question_type}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-semibold">
                        Question Limit
                      </label>

                      <input
                        type="text"
                        name="question_limit"
                        className="form-control"
                        placeholder="Enter Question Limit"
                        value={formData.question_limit}
                        onChange={(e) => {
                          // allow only numbers
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          setFormData((prev) => ({
                            ...prev,
                            question_limit: value,
                          }));
                        }}
                        pattern="[0-9]*"
                        inputMode="numeric"
                        required
                      />
                    </div>

                  </div>

                  <div className="mt-3">
                    <button
                      type="submit"
                      className="btn btn-success me-2"
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Submit"}
                    </button>

                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => navigate("/PreparequestionType")}
                    >
                      Cancel
                    </button>
                  </div>

                </form>

              </div>
            </div>

          </div>

          <footer className="footer mt-4">
            <span className="text-muted">
              © {new Date().getFullYear()} Vijaya Diagnostic Centre
            </span>
          </footer>

        </div>
      </div>
    </div>
  );
};

export default AddQuestionType;
